import * as React from "react";
import "./LogoutView.css";

interface IProps
{
    onLogout();
}

export default function LogoutView(props: IProps)
{
    return <a className="logout-button" onClick={props.onLogout}>Log out</a>;
}
